# WHERE PIPER AUDIO IS SERVED FROM — one definition.
#
# instruction_set.coffee built this URL inline at say() time, and it was the
# only place that knew it. The warm-up (card 6aaa14f67fc38cab6b35ae09) has to
# fetch the SAME url the say path will ask for a moment later, or the cache it
# fills is a cache nothing reads — so the host is a constant both import
# rather than a literal each spells for itself.
export AUDIO_CDN_BASE = 'https://d2l4gvz6xsdl0z.cloudfront.net/'

# EVERY REQUEST FOR A CLIP IS ONE CORS REQUEST — owner 2026-09-26. The warm-up
# (fetch, mode 'cors'), SoundJS (iOS app and Safari: a CORS XHR) and <audio>
# (crossOrigin 'anonymous') all ask the same way, so the one cache entry they
# share always carries allow-origin. CloudFront answers allow-origin only to a
# request bearing an Origin and sends no `Vary: Origin`, so a copy cached from a
# no-Origin request is refused to a later CORS load: that is how el-feet
# cbc2748's no-cors warm-up sent iOS and Safari to browser speech. This query
# is a fresh cache key: copies browsers cached WITHOUT allow-origin under the
# bare url are never reused.
export AUDIO_CDN_QUERY = '?v=cors'
